import React from 'react';
import { Grid } from '@mui/material';
import { CampaignFormProvider } from 'context';
import { CampaignForm, RightSidebar } from 'components';

export const CampaignCreatePage = () => {
  return (
    <Grid container spacing={6}>
      <CampaignFormProvider isCreateCampaignFlow>
        {/* order will put this element after right sidebar on mobile */}
        <Grid item xs={12} md={9} sx={{ order: { xs: 1, sm: 0 } }}>
          <CampaignForm />
        </Grid>
        <Grid item xs={12} md={3}>
          <RightSidebar />
        </Grid>
      </CampaignFormProvider>
    </Grid>
  );
};
